import { finish, error } from '../../../modules/events/actions/get';
import api from '../../../api';

export function request(dispatch, { id }) {
    api.get('/events/' + id, void 0, { cache: true }).then(
        (data) => dispatch(finish(id, data)),
        ({ errors }) => dispatch(error(id, errors))
    );
}
